import React, { useState } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';
import { COMPREHENSIVE_RATING_COLOR, OrderPreRating } from '../../../types/process/order-pre-rating';
import PreRatingModal from './modals/PreRatingModal';

const { Text } = Typography;

interface OrderPreRatingSummaryProps {
  orderNo: string;
  preRating?: OrderPreRating | null;
  headerExtra?: React.ReactNode;
}

const OrderPreRatingSummary: React.FC<OrderPreRatingSummaryProps> = ({ orderNo, preRating, headerExtra }) => {
  const [isPreRatingModalVisible, setIsPreRatingModalVisible] = useState(false);
  const ratingLetter = preRating?.comprehensiveRating ?? 'UNKNOWN';
  const ratingColor = COMPREHENSIVE_RATING_COLOR[ratingLetter] ?? '#999';
  const ratingBadgeText = ratingLetter === 'UNKNOWN' ? '待' : ratingLetter;
  const ratingBadgeColor = ratingLetter === 'UNKNOWN' ? '#98a2b3' : ratingColor;
  const openPreRatingModal = () => setIsPreRatingModalVisible(true);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button
          type="button"
          onClick={openPreRatingModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: 0,
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            textAlign: 'left',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tooltip title="查看订单预评级详情" mouseEnterDelay={0.2}>
              <QuestionCircleOutlined style={{ fontSize: 15, color: '#2f80ed', flex: '0 0 auto' }} />
            </Tooltip>
            <Text
              strong
              style={{
                fontSize: 14,
                lineHeight: '22px',
                color: '#1f2937',
              }}
            >
              订单预评级：
            </Text>
          </div>
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: 5,
              border: `2px solid ${ratingBadgeColor}`,
              background: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: ratingBadgeColor,
              fontSize: ratingLetter === 'UNKNOWN' ? 18 : 28,
              fontWeight: 700,
              lineHeight: 1,
              boxSizing: 'border-box',
              flex: '0 0 42px',
            }}
          >
            {ratingBadgeText}
          </div>
        </button>
        {headerExtra ? <div style={{ display: 'flex', alignItems: 'center' }}>{headerExtra}</div> : null}
      </div>
      <PreRatingModal
        orderNo={orderNo}
        visible={isPreRatingModalVisible}
        onClose={() => setIsPreRatingModalVisible(false)}
      />
    </>
  );
};

export default OrderPreRatingSummary;
